const TRANSLATIONS_CA = {};

export default TRANSLATIONS_CA;
